import precisionMedium from './chunks/precision.medium.glsl.js';
import defaultVaryings from './chunks/default.varyings.glsl.js';
var shaderPassFS = precisionMedium + defaultVaryings + "\nuniform sampler2D uRenderTexture;\n\nvoid main() {\n    gl_FragColor = texture2D(uRenderTexture, vTextureCoord);\n}\n";
export default shaderPassFS.replace(/\n/g, '');